import { lazy } from 'react';

export const AsyncPricingPageContainer = lazy(() => import(
  /* webpackChunkName: 'pricing_page' */
  './PricingPageContainer'
));
